var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18V28C7.5 35.5424 7.5 39.3138 9.84314 41.6568C12.1863 44 15.9575 44 23.5 44H25.5C33.0424 44 36.8138 44 39.1568 41.6568C41.5 39.3138 41.5 35.5424 41.5 28V20C41.5 12.4575 41.5 8.6863 39.1568 6.34314C36.8138 4 33.0424 4 25.5 4H24.5",
    stroke: "#141B34",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 34H35.5",
    stroke: "#141B34",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 14H35.5",
    stroke: "#141B34",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 24H35.5",
    stroke: "#141B34",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 33C13.5 33 15.4352 33.5344 16.5 36C16.5 36 18.5 30 22.5 28",
    stroke: "#141B34",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10H7.5M20.5 10C20.5 8.31946 15.8466 5.17968 14.6667 4M20.5 10C20.5 11.6805 15.8466 14.8203 14.6667 16",
    stroke: "#141B34",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToList);
export default __webpack_public_path__ + "static/media/add-to-list.2dc8de3263bf22450007f72f6b434994.svg";
export { ForwardRef as ReactComponent };